import { createTheme } from '@mui/material/styles';

export const tele2Theme = createTheme({
  // status: {
  //   danger: '#e53e3e',
  // },
  palette: {
    primary: {
      // main: '#0971f1',
      main: '#000',
      darker: '#053e85',
      mainRGB: '20, 22, 23'
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});